/**
 * Valida paths internos sugeridos pelo assistente (evita open redirect).
 * Exigir uma única barra inicial já descarta esquemas (`javascript:`, `http:`) e
 * `//host`, que o navegador resolve como origem externa.
 * @param {string | undefined | null} path
 * @returns {string | null}
 */
export function safeInternalPath(path) {
  if (typeof path !== 'string') return null;
  const trimmed = path.trim();
  if (!trimmed.startsWith('/') || /^\/[/\\]/.test(trimmed)) return null;
  return trimmed;
}
